import PopupNew from 'client/components/entities/popup-new'
import { WORK_AREA_ID } from 'client/constants/editorIds'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { useManagement, usePage } from 'client/store'
import managementSelectors from 'client/store/management/managementSelectors'
import pageSelectors from 'client/store/page/pageSelectors'
import { commonModalWidth } from 'common/constants/commonWidth'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { PopupInterface } from 'common/types/entities/popup-interface'
import React from 'react'
import { createPortal } from 'react-dom'
import { PopupWrapperUi } from './ui/popup-wrapper-ui'

const getPopupWidth = (
  popup: PopupInterface | OldEntityInterface,
  isMobile: boolean,
) => {
  if (isMobile) return 'auto'

  const width =
    popup.type === EntityTypeEnum.Popup ? popup.width : popup.styles?.width

  return width ? `${width}px` : `${commonModalWidth}px`
}

export const ActivePopup = () => {
  const { isMobile } = useDeviceModeContext()

  const activePopupId = useManagement(managementSelectors.getActivePopupId)
  const popup = usePage(page =>
    pageSelectors.getEntityById(page, activePopupId),
  ) as PopupInterface | null

  if (!popup) {
    return null
  }

  return createPortal(
    <PopupWrapperUi width={getPopupWidth(popup, isMobile)}>
      <PopupNew entity={popup} />
    </PopupWrapperUi>,
    document.getElementById(WORK_AREA_ID) as HTMLElement,
  )
}
